import moment from 'moment';

const date = function(value) {
  if(value == null) return true;
  return moment(value).isValid();
};

const daterequired = function(value) {
  if (value) {
    return moment(value).isValid();
  }else {
    return false;
  }

};

export { date, daterequired };
